module.exports = __webpack_public_path__ + "img/appstore.882283fe.png";